import React, { useState, useEffect } from 'react';
import SearchMyTalentsFilter from './SearchMyTalentsFilter';
import { useParams } from 'react-router-dom';
import useFetchTalents from '../../../../../hooks/talents/useFetchTalents';
import MyTalentCard from './MyTalentCard/MyTalentCard';
import Loading from '../../../Loading/Loading';
import { useRestaurant } from '../../../../../context/RestaurantContext';
import './myTalentsView.css';

const MyTalentsView = ({ mode }) => {
    const { id } = useParams();
    const [searching, setSearching] = useState(false);
    const [flashMessage, setFlashMessage] = useState('')
    const { talents, loading, error, setTalents, triggerFetchTalents } = useFetchTalents()
    const { restaurantId } = useRestaurant();

    useEffect(() => {  
        triggerFetchTalents();
    }, [id, mode, restaurantId]); 

    const handleSearchFilter = async (filters) => {
        setSearching(true);
        try {
            // Add restaurantId to filters
            const filtersWithRestaurant = { ...filters, restaurantId };
            const queryParams = new URLSearchParams(filtersWithRestaurant).toString();
    
            const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/talent-pool?${queryParams}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
    
            if (!response.ok) throw new Error('Failed to fetch filtered data');
            const data = await response.json();
            
            // Ensure we always set an array
            const talentsArray = Array.isArray(data) ? data : (data.talents || data.data || []);
            setTalents(talentsArray); 
        } catch (error) {
            console.error('Error fetching filtered data:', error);
            setTalents([]); // Ensure talents remains an empty array on error
        } finally {
            setSearching(false);
        }
    };

    const handleDeleteSuccess = () => {
        triggerFetchTalents();
        displayFlashMessage('Talento eliminado')
    };
    
    const displayFlashMessage = (message) => {
        setFlashMessage(message);
        setTimeout(() => {
          setFlashMessage(null);
        }, 3000); 
    };

    if (loading || searching) {
        return <Loading />;
    }

    return (
      <>
        {flashMessage && (
            <div className="flash-message">
            <p>{flashMessage}</p>
            </div>
        )}
        <div className="">
            <div className="my-talents-view__container">
                <h1>Mis talentos</h1>
                <SearchMyTalentsFilter handleSearchFilter={handleSearchFilter} />
                
                {error && (
                    <div className="error-message">
                        <p>Error: {error}</p>
                    </div>
                )}
                
                <div>
                    {Array.isArray(talents) && talents.length > 0 ? (
                        talents.map((employee) => (
                            <MyTalentCard
                                key={employee.id}
                                data={employee.employee}
                                id={employee.id}
                                employeeId={employee.employeeId}
                                type="dashboard"
                                mode={mode}
                                onDeleteSuccess={handleDeleteSuccess}
                            />
                        ))
                    ) : (
                        !error && (
                            <div className="no-talents-message">
                                <p>No tienes talentos guardados aún. Usa el buscador de talentos para encontrar y guardar empleados.</p>
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
      </> 
    );
};

export default MyTalentsView;